const commandListDelay = {

	'forward': ( token, delay ) => {

		if ( isNumber( token.arg ) ) {
			delay = Math.round( token.arg * 1.5 );
			delay = Math.min( delay, 35 );
		}

		return delay;

	},

	'setbg': () => {
		return 400;
	},

}


const commandList = {

	'fd': [ 'forward', 1 ],
	'forward': [ 'forward', 1 ],

	'bk': [ 'backward', 1 ],
	'back': [ 'backward', 1 ],
	'backward': [ 'backward', 1 ],

	'lt': [ 'left', 1 ],
	'left': [ 'left', 1 ],

	'rt': [ 'right', 1 ],
	'right': [ 'right', 1 ],

	'arc': [ 'arc', 2 ],

	'seta': [ 'seta', 1 ],
	'setangle': [ 'seta', 1 ],
	'setheading': [ 'seta', 1 ],
	'seth': [ 'seta', 1 ],

	'setbg': [ 'setbg', 1 ],

	'color': [ 'colour', 1 ],
	'colour': [ 'colour', 1 ],
	'colorrand': [ 'colourrand' ],
	'colourrand': [ 'colourrand' ],

	'width': [ 'setwidth', 1 ],
	'setwidth': [ 'setwidth', 1 ],
	'setw': [ 'setwidth', 1 ],

	'fill': [ 'fill' ],

	'pu': [ 'penup' ],
	'penup': [ 'penup' ],

	'showcursor': [ 'showcursor' ],
	'hidecursor': [ 'hidecursor' ],

	'pd': [ 'pendown' ],
	'pendown': [ 'pendown' ],

	'home': [ 'home' ],

	'setxy': [ 'setxy', 2 ],
	'position': [ 'setxy', 2 ],
	'setx': [ 'setx', 1 ],
	'sety': [ 'sety', 1 ],

	'delay': [ 'delay', 1 ],
	'wait': [ 'delay', 1 ],

	'clear': [ 'clear' ],

};



